<ng-container *ngIf="form">
  <app-custom-input-password
    [label]="'manage-account.current-password.label' | translate"
    [placeholder]="'manage-account.current-password.label' | translate"
    key="currentPassword"
    [control]="currentPasswordControl"
    [submitted]="showErrors || (currentPasswordControl.dirty && !currentPasswordControl.valid)"
    [errorsList]="errorsList.currentPassword"
    [isRequired]="true">
  </app-custom-input-password>

  <app-custom-input-password
    [label]="'manage-account.new-password.label' | translate"
    [placeholder]="'manage-account.new-password.label' | translate"
    key="newPassword"
    [control]="newPasswordControl"
    [submitted]="showErrors || (newPasswordControl.dirty && !newPasswordControl.valid)"
    [errorsList]="errorsList.newPassword"
    [isRequired]="true">
  </app-custom-input-password>

  <app-custom-input-password
    [label]="'manage-account.confirm-password.label' | translate"
    [placeholder]="'manage-account.confirm-password.label' | translate"
    key="confirmPassword"
    [control]="confirmPasswordControl"
    [submitted]="showErrors || (confirmPasswordControl.dirty && !confirmPasswordControl.valid)"
    [errorsList]="errorsList.confirmPassword"
    [isRequired]="true">
  </app-custom-input-password>
</ng-container>
